import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Table from "components/Admin/Transactions/Transactions";
import Card from "components/Shared/Card/Card.js";
import CardHeader from "components/Shared/Card/CardHeader/CardHeader.js";
import CardBody from "components/Shared/Card/CardBody/CardBody.js";

import { getTransactions } from "store/actions/transactions";

const Transactions = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const transactionsData = useSelector(
    (state) => state.transactions.transactions
  );
  const [page, setPage] = useState(
    transactionsData ? transactionsData.pag.page : 1
  );
  const [amount, setAmount] = useState(
    transactionsData ? transactionsData.pag.amount : 10
  );
  const [orderField, setOrderField] = useState(
    transactionsData ? transactionsData.pag.order_field : "created_at"
  );
  const [orderType, setOrderType] = useState(
    transactionsData ? transactionsData.pag.order_type : "desc"
  );
  const [searchValue, setSearchValue] = useState("");

  const [searchBy, setSearchBy] = useState(
    transactionsData ? transactionsData.pag.search_by : "client_name"
  );

  useEffect(() => {
    dispatch(
      getTransactions(
        {
          page,
          amount,
          order_field: orderField,
          order_type: orderType,
          search_value: searchValue,
          search_by: searchBy,
        },
        history
      )
    );
  }, [page, amount, orderField, orderType, searchValue, history, dispatch]);

  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4>Transactions Table</h4>
        </CardHeader>
        <CardBody>
          {transactionsData && (
            <Table
              rows={transactionsData.data}
              totalRows={transactionsData.pag.total}
              rowsPerPage={amount}
              setRowsPerPage={setAmount}
              order={orderType}
              setOrder={setOrderType}
              orderBy={orderField}
              setOrderBy={setOrderField}
              page={page - 1}
              setPage={setPage}
              searchHandler={setSearchValue}
              searchValue={searchValue}
              selectedSearchBy={searchBy}
              handleSearchByChange={setSearchBy}
              //
            />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Transactions;
